import { type CellObserver, type ObservableModule, type ObservableVariable } from "./interfaces";

/* This is a wrapper class for ObservableVariable that helps us provide more
 * useful types to the typescript compiler.
 *
 * Observables' own variable implmentation is untyped, and uses variadic arguments
 * to overload methods like `define`. This makes the typescript compiler very angry
 * this class helps.
 */
export class Variable {
	private variable: ObservableVariable;

	constructor(module: ObservableModule, observer?: CellObserver) {
		this.variable = module.variable(observer);
	}

	define({
		name,
		inputs,
		definition,
	}: {
		name?: string;
		inputs?: string[];
		// definition will end up receiving as arguments the variables referenced in inputs
		// in the order in which they were requested.
		//
		// as an example: if you defined a variable "x" with the inputs ["y", "z"]
		// you could then give this a define function like:
		//
		// (y, z) => 10
		definition: (...args: unknown[]) => unknown;
	}) {
		this.variable.define(name, inputs, definition);
	}

	delete() {
		this.variable.delete();
	}

	createImport(imported: string, localIdentifier: string, module: ObservableModule) {
		this.variable.import(imported, localIdentifier, module);
	}
}
